export const selectUsername = (state) => state.user.name;
export const selectEmail = (state) => state.user.email;
export const selectError = (state) => state.user.error;
export const selectRoles = (state) => state.user.role;